var exports = {
  "D": "xdde3148b--a3d4d8--title",
};

module.exports = exports;
